export function layoutIs(modifier: string): boolean {
  return !!document.querySelector(`.frontend-layout.-${modifier}`)
}

export function isIOSApp(): boolean {
  return isNativeApp() && isIOS()
}

export function isNativeApp(): boolean {
  return document.body.getAttribute('data-native-app') === 'true'
}

export function isIOS(): boolean {
  return isIPhone() || isIPad()
}

export function isIPhone(): boolean {
  return /iPhone/.test(navigator.userAgent)
}

export function isIPad(): boolean {
  return (
    /iPad/.test(navigator.userAgent) ||
    (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent))
  )
}

export function isGoogleBot(): boolean {
  return /googlebot/i.test(navigator.userAgent)
}

export function isMsEdge(): boolean {
  return / Edg\//.test(navigator.userAgent)
}

export function isSafari(): boolean {
  return navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0
}

export function appVersionAtLeast(...version: (number | string)[]): boolean {
  const match = _extractVersion()
  if (match) {
    const parts = match[1].split('.')
    for (let i = 0; i < version.length; i++) {
      if (i < parts.length) {
        const actualPart = parseInt(parts[i])
        const comparisonPart = parseInt(String(version[i]))
        if (actualPart < comparisonPart) {
          return false
        } else if (actualPart > comparisonPart) {
          return true
        }
      } else {
        return false
      }
    }
    return true
  } else {
    // not in app at all
    return false
  }
}

function _extractVersion(): RegExpMatchArray | null {
  return _extractVersionOldAgent() || _extractVersionNewAgent()
}

function _extractVersionOldAgent(): RegExpMatchArray | null {
  return navigator.userAgent.match(/Studyflix App \([^;]*; v([^)]*)\)/)
}

function _extractVersionNewAgent(): RegExpMatchArray | null {
  return navigator.userAgent.match(/StudyflixApp\/(\d*\.\d*(\.\d*)?(-\d*)?)/)
}
